export enum TaxDisplayType {
    IncludingTax = 0,
    ExcludingTax = 10
}